import {Routing} from 'nutshell-core/routing';

// If the previous value is 0, delta will always be null. But we still need a mood and direction
export function getNullDeltaDirectionAndMood(
    formattedPreviousValue: string,
    formattedValue: string
) {
    const curr = Number(formattedValue.replace(/,/g, ''));
    const prev = Number(formattedPreviousValue.replace(/,/g, ''));
    if (prev === curr) {
        return 'CONSTANT';
    } else if (prev < curr) {
        return 'INCREASE';
    } else {
        return 'DECREASE';
    }
}

export function getLeadsLink(timespan: string, originId: string) {
    const urlParams = {
        fields: {leads: 'name,createdTime,value,owner,milestone,confidence,closedTime,sources'},
        view: 'list',
        filter: {
            period: timespan,
            createdTime: timespan,
            origin: {
                anyAll: 'any',
                data: [{data: originId}],
            },
        },
    } as const;
    const paramedNewValue = Routing.param(urlParams);

    return `/leads?${paramedNewValue}`;
}

export function getVisitorsLink(timespan: string) {
    const urlParams = {
        filter: {
            period: timespan,
            createdTime: timespan,
        },
    } as const;

    const paramedNewValue = Routing.param(urlParams);

    return `/email-marketing/visitors/list?${paramedNewValue}`;
}
